export const constants = {
  isDevice: null,
}

export const instances = {
  loading: null,
}
